import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const JourneyFrame = ({ step, total, onBack, onContinue, continueLabel = "Continue", continueDisabled, onSkip, children }) => (
  <div className="container-site max-w-2xl pt-6 pb-36" data-testid="journey-frame">
    <div className="flex items-center justify-between gap-3 text-sm">
      <span className="font-semibold text-ink-soft" aria-live="polite" data-testid="journey-progress-label">Step {step} of {total}</span>
      <Link to="/urgent-help" className="font-semibold text-clay-dark underline underline-offset-4" data-testid="journey-help-now-link">Need help now?</Link>
    </div>
    <div className="mt-2 h-1.5 rounded-full bg-cream-deep" role="progressbar" aria-label="Journey progress" aria-valuemin={1} aria-valuemax={total} aria-valuenow={step}>
      <div className="h-full rounded-full bg-teal transition-[width] duration-300" style={{ width: `${(step / total) * 100}%` }} />
    </div>
    <div className="mt-8">{children}</div>
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-cream-deep bg-cream/95 backdrop-blur-md no-print">
      <div className="container-site max-w-2xl flex items-center gap-2 py-3">
        <button type="button" onClick={onBack} className="btn-secondary !px-4 sm:!px-5" data-testid="journey-back-button"><ArrowLeft className="h-4 w-4" aria-hidden="true" />Back</button>
        <div className="ml-auto flex items-center gap-3">
          {onSkip && <button type="button" onClick={onSkip} className="btn-ghost px-2 min-h-[44px]" data-testid="journey-skip-button">Skip</button>}
          <button type="button" onClick={onContinue} disabled={continueDisabled} className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed" data-testid="journey-continue-button">{continueLabel}</button>
        </div>
      </div>
    </div>
  </div>
);
